import * as r from 'ramda';
import { nullMap } from "./util"

export default function eventMixin(obj, helpers = {}) {
  obj._events = {};
  const defaultHandlers = {
    onFirstSubscribe: () => {},
    onSubscribe: () => {},
    onUnsubscribe: () => {},
    onLastUnsubscribe: () => {}
  };
  if (r.without(r.keys(defaultHandlers), r.keys(helpers)).length > 0) {
    throw new Error("Invalid helpers to event mixin: " + r.without(r.keys(defaultHandlers), r.keys(helpers)) + " only " + r.keys(defaultHandlers) + " allowed.");
  }
  helpers = Object.assign(defaultHandlers, helpers);

  obj.on = (event, listener) => {
    if (r.isNil(obj._events[event])) {
      obj._events[event] = [];
    }
    obj._events[event].push(listener);
    if (obj._events[event].length === 1) {
      helpers.onFirstSubscribe(event);
    }
    helpers.onSubscribe(event, listener);
    return listener;
  };

  obj.emit = (event, ...args) => nullMap(r.forEach(listener => listener.apply(obj,args)), obj._events[event]);

  obj.removeListener = (event, listener) => nullMap(() => {
      obj._events[event] = r.without([listener], obj._events[event]);
      helpers.onUnsubscribe(event, listener);
      if (obj._events[event].length === 0) {
        helpers.onLastUnsubscribe(event);
      }
    })(obj._events[event]);

  obj.off = obj.removeListener;

  obj.hasListeners = (event) => r.complement(r.isEmpty)(obj._events[event]);

  obj.once = (event, listener) => {
    return new Promise(resolve => {
      obj.on(event, function handler(...args) {
        obj.removeListener(event, handler);
        if (listener)
          listener.apply(obj, args);
        resolve(args.length === 0 ? undefined : args.length === 1 ? args[0] : args)
      });
    })
  };
}


// WEBPACK FOOTER //
// ./src/api/event-mixin.js